/**
 * 一覧へ戻るボタンの行き先を、直前に見ていたページに合わせる
 *
 * @description 一覧は /creators/page/3/ のようにURLでページを持つ。記事から戻るとき、
 *              テンプレートが持つ既定の行き先は1ページ目なので、見ていた位置を覚えて差し替える。
 *
 *              覚える行き先はサーバーが書き出した canonical を読む。非同期遷移の最中は
 *              location がまだ前のページを指していることがあり、番地を1つ前へ取り違えるため。
 *
 *              覚え書きが無いときは既定の1ページ目へ戻るだけなので、JSが動かなくても壊れない。
 */

/** 覚え書きの名前。一覧の種類ごとに分ける */
const KEY_PREFIX = 'oneview:backlink-';

/**
 * 覚えている行き先を読む
 *
 * @param kind 一覧の種類
 * @returns 覚えていなければ空文字
 */
const readMemo = (kind: string): string => {
    try {
        return sessionStorage.getItem(KEY_PREFIX + kind) ?? '';
    } catch {
        // プライベートウィンドウなどで読めないことがある。覚えていない扱いでよい
        return '';
    }
};

/**
 * 行き先を覚える
 *
 * @param kind 一覧の種類
 * @param url 一覧のURL
 * @returns {void}
 */
const writeMemo = (kind: string, url: string): void => {
    try {
        sessionStorage.setItem(KEY_PREFIX + kind, url);
    } catch {
        // 書けなくても既定の行き先で戻れる
    }
};

/**
 * 一覧を見ていたことを控え、記事の戻るボタンをそこへ向ける
 *
 * @param scope 新しい器。非同期遷移の最中は古い器も残っているので探索範囲を絞る
 * @returns {void}
 */
const initBackLink = (scope: ParentNode = document): void => {
    const list = scope.querySelector<HTMLElement>('[data-listmemo][data-listmemo-url]');

    if (list) {
        writeMemo(list.dataset.listmemo ?? '', list.dataset.listmemoUrl ?? '');
    }

    scope.querySelectorAll<HTMLAnchorElement>('a[data-backto]').forEach((btn) => {
        const memo = readMemo(btn.dataset.backto ?? '');

        if (memo) {
            btn.href = memo;
        }
    });
};

export { initBackLink };

document.addEventListener('DOMContentLoaded', () => initBackLink());
